import * as React from "react";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";


interface HeroTextOnRightBlockProps {
  /** TYTUŁ */
  titleLine1: string
  titleLine2?: string

  /** OPIS */
  description: string[]

  /** TEXTS PRZYCISKU */
  buttonText: string

  /** ADRES ODNOŚNIKA => OTWIERANY BĘDZIE W NOWYM OKNIE */
  buttonLink: string

  /** INFORMACJA CZY PRZYCISK TEN MA SCROLOWAĆ CZY ODSYŁAĆ DO INNEGO MIEJSCA */
  buttonLinkIsForScrolling?: boolean

  /** ZDJĘCIE W TLE */
  backgroundImage: string

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType
}

interface HeroTextOnRightBlockState {}

class HeroTextOnRightBlock extends React.Component<HeroTextOnRightBlockProps,HeroTextOnRightBlockState> {

  constructor(props: HeroTextOnRightBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onButtonClick() {
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  render() {
    // DANE UNIWERSALNE
    const {
      titleLine1,
      titleLine2,
      description,
      buttonText,
      buttonLink,
      backgroundImage
    } = this.props;

    // ZWRACANIE DANYCH
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <HeroBlockWrapper className="parallax-bg valign-wrapper" backgroundImage={backgroundImage}>
          <div className="valign-cell">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-md-offset-6 col-sm-offset-4 col-sm-8 col-xs-12">
                  <h1 className="intro-title intro-h1">
                    {titleLine1}
                    {/* SPACJA => W TEKŚCIE H1 LINIE NIE SKLEJAJĄ SIĘ ("ZUS?To") */}
                    {titleLine2 && " "}
                    {titleLine2 && <span/>}
                    {titleLine2 && titleLine2}
                  </h1>
                  {description.map((description: string, index: number) => <HeroBlockTitleDescriptionWrapper key={index} className="lead">{description}</HeroBlockTitleDescriptionWrapper>)}
                  <a href={buttonLink} target={this.props.buttonLinkIsForScrolling ? "" : "_blank"} className="btn btn-lg waves-effect waves-light mt-20" onClick={this.onButtonClick}>{buttonText}</a>
                </div>
              </div>
            </div>
          </div>
        </HeroBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const HeroBlockWrapper: any = styled.section`
  background-image: url(${(props: any) => props.backgroundImage});
  background-size: cover !important;
  background-attachment: inherit !important;
  height: 600px !important;
  div.container {
    width: 90%;
  }
  /* TELEFON => STAŁY NAGŁÓWEK MA OK. 117PX, A TREŚĆ HERO JEST WYŻSZA NIŻ 600PX => H1 CHOWAŁ SIĘ POD MENU */
  @media (max-width: 600px) {
    height: auto !important;
    padding-top: 130px;
    padding-bottom: 40px;
  }
  /* BARDZO WĄSKI EKRAN => MENU ZAWIJA SIĘ, NAGŁÓWEK MA OK. 153PX */
  @media (max-width: 360px) {
    padding-top: 165px;
  }
  @media (max-width: 1200px) {
    h1.intro-title {
      font-size: 32px !important;
    }
  }
  h1.intro-h1 {
    font-size: 40px !important;
    line-height: 44px !important;
    margin: 0 0 20px 0;
    span {
      display: block;
    }
  }
`;

const HeroBlockTitleDescriptionWrapper = styled.p`
  color: black;
`;

export default HeroTextOnRightBlock


// WEBPACK FOOTER //
// ./src/layouts/hero-text-on-right-block/hero-text-on-right-block.tsx